import { IconRepository } from '../types';
import * as icons from './icons';

export const CORE_ICONS: IconRepository = icons as unknown as IconRepository;

export * from './coreBrandAssets';
export * from './icons';
export * from './images';
export * from './TenantAsset';
export * from './TenantBrandAssets';
